import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useTrip } from './tripContext.jsx';
import { fetchSession } from './briefingApi.js';

// Session state from /api/auth/session. Phase 5 wires this up so the
// app can route Anar to the spectator dashboard, players to /wilman,
// and unauthenticated visitors to a "you need a briefing link" page.
//
// Best-effort: if the cookie is unset (most local/dev visits) the
// context resolves to { ok: false } and the app continues in
// pre-Phase-5 "trust localStorage active player" mode. Phase 9 testing
// will tighten this gating.

const SessionContext = createContext({ loading: true, ok: false });

export function SessionProvider({ children }) {
  const { tripId } = useTrip();
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    let cancelled = false;
    fetchSession({ tripId })
      .then((s) => {
        if (!cancelled) setState({ loading: false, ok: !!s.ok, ...s });
      })
      .catch(() => {
        if (!cancelled) setState({ loading: false, ok: false });
      });
    return () => {
      cancelled = true;
    };
  }, [tripId]);

  const value = useMemo(() => state, [state]);
  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>;
}

export function useSession() {
  return useContext(SessionContext);
}
